'use strict';

export const ConstUnitText = [
    { code: 0x0000, text: '*' },
    { code: 0x0001, text: String.fromCharCode(8451) }, // temperature deg
    { code: 0x0002, text: 'kg' },
    { code: 0x0003, text: 'MPa' },
    { code: 0x0004, text: 'bar' },
    { code: 0x0005, text: 'mmHg' },
    { code: 0x0006, text: 'mmAq' },
    { code: 0x0007, text: 'rpm' },
    { code: 0x0008, text: '10rpm' },
    { code: 0x0009, text: String.fromCharCode(0xe3, 0x8e, 0xa5) }, // square m cubed
    { code: 0x0010, text: 'L' },
    { code: 0x0011, text: '10L' },
    { code: 0x0012, text: '100L' },
    { code: 0x0013, text: 'kL' },
    { code: 0x0014, text: 'REV' },
    { code: 0x0015, text: '10REV' },
    { code: 0x0016, text: 'N' },
    { code: 0x0017, text: 'DEG' },
    { code: 0x0018, text: '%' },
    { code: 0x0019, text: 'V' },
    { code: 0x0020, text: 'A' },
    { code: 0x0021, text: 'kW' },
    { code: 0x0022, text: 'Hz' },
    { code: 0x0023, text: 'PS' },
    { code: 0x0024, text: '10PS' },
    { code: 0x0025, text: '100PS' },
    { code: 0x0026, text: 'cSt' },
    { code: 0x0027, text: 'nm' },
    { code: 0x0028, text: 'ppm' },
    { code: 0x0029, text: 'sec' },
    { code: 0x0030, text: 'min' },
    { code: 0x0031, text: 'hour' },
    { code: 0x0032, text: 'HR.M' },
    { code: 0x0033, text: 'mm' },
    { code: 0x0034, text: 'cm' },
    { code: 0x0035, text: 'm' },
];

export const ConstStatusText = [
    { code: 0x0000, text: '*/*' },
    { code: 0x0001, text: 'ON/OFF' },
    { code: 0x0002, text: 'OFF/ON' },
    { code: 0x0003, text: 'SHUT/OPEN' },
    { code: 0x0004, text: 'OPEN/SHUT' },
    { code: 0x0005, text: 'CLOSE/OPEN' },
    { code: 0x0006, text: 'OPEN/CLOSE' },
    { code: 0x0007, text: 'NOR/ABNOR' },
    { code: 0x0008, text: 'ABNOR/NOR' },
    { code: 0x0009, text: 'NOR/TRBL' },
    { code: 0x000a, text: 'TRBL/NOR' },
    { code: 0x000b, text: 'NOR/CANCEL' },
    { code: 0x000c, text: 'CANCEL/NOR' },
    { code: 0x000d, text: 'NOR/HIGH' },
    { code: 0x000e, text: 'HIGH/NOR' },
    { code: 0x000f, text: 'NOR/LOW' },
    { code: 0x0010, text: 'LOW/NOR' },
    { code: 0x0011, text: 'NOR/LL' },
    { code: 0x0012, text: 'LL/NOR' },
    { code: 0x0013, text: 'NOR/HH' },
    { code: 0x0014, text: 'HH/NOR' },
    { code: 0x0015, text: 'NOR/CLOSE' },
    { code: 0x0016, text: 'CLOSE/NOR' },
    { code: 0x0017, text: 'NOR/TRIP' },
    { code: 0x0018, text: 'TRIP/NOR' },
    { code: 0x0019, text: 'USE/NO USE' },
    { code: 0x001a, text: 'NO USE/USE' },
    { code: 0x001b, text: 'DO/HFO' },
    { code: 0x001c, text: 'HFO/DO' },
    { code: 0x001d, text: 'DISEN/ENGA' },
    { code: 0x001e, text: 'ENGA/DISEN' },
    { code: 0x001f, text: 'ACT/STOP' },
    { code: 0x0020, text: 'STOP/ACT' },
    { code: 0x0021, text: 'START/STOP' },
    { code: 0x0022, text: 'STOP/START' },
    { code: 0x0023, text: 'RUN/STOP' },
    { code: 0x0024, text: 'STOP/RUN' },
    { code: 0x0025, text: 'NOR/EH' },
    { code: 0x0026, text: 'EH/NOR' },
    { code: 0x0027, text: 'NOR/EL' },
    { code: 0x0028, text: 'EL/NOR' },
    { code: 0x0029, text: 'ON/*' },
    { code: 0x002a, text: '*/ON' },
    { code: 0x002b, text: 'OPEN/*' },
    { code: 0x002c, text: '*/OPEN' },
    { code: 0x002d, text: 'SHUT/*' },
    { code: 0x002e, text: '*/SHUT' },
    { code: 0x002f, text: 'TRIP/*' },
    { code: 0x0030, text: '*/TRIP' },
    { code: 0x0031, text: 'NOR/*' },
    { code: 0x0032, text: '*/NOR' },
    { code: 0x0033, text: 'ABNOR/*' },
    { code: 0x0034, text: '*/ABNOR' },
    { code: 0x0035, text: 'FAIL/*' },
    { code: 0x0036, text: '*/FAIL' },
    { code: 0x0037, text: 'USE/*' },
    { code: 0x0038, text: '*/USE' },
    { code: 0x0039, text: 'AUTO/*' },
    { code: 0x003a, text: '*/AUTO' },
    { code: 0x003b, text: 'DUTY/*' },
    { code: 0x003c, text: '*/DUTY' },
    { code: 0x003d, text: 'CANCEL/*' },
    { code: 0x003e, text: '*/CANCEL' },
    { code: 0x003f, text: 'READY/*' },
    { code: 0x0040, text: '*/READY' },
    { code: 0x0041, text: 'COND/*' },
    { code: 0x0042, text: '*/COND' },
    { code: 0x0043, text: 'CLEAR/*' },
    { code: 0x0044, text: '*/CLEAR' },
    { code: 0x0045, text: 'RUN/*' },
    { code: 0x0046, text: '*/RUN' },
    { code: 0x0047, text: 'BLOCK/SERV' },
    { code: 0x0048, text: 'SERV/BLOCK' },
    { code: 0x0049, text: '*/LOW' },
    { code: 0x004a, text: 'LOW/*' },
    { code: 0x004b, text: '*/HIGH' },
    { code: 0x004c, text: 'HIGH/*' },
    { code: 0x004d, text: 'PASS/*' },
    { code: 0x004e, text: '*/PASS' },
    { code: 0x004f, text: 'OK/*' },
    { code: 0x0050, text: '*/OK' },
    { code: 0x0051, text: 'STOP/*' },
    { code: 0x0052, text: '*/STOP' },
    { code: 0x0053, text: 'CLOSE/*' },
    { code: 0x0054, text: '*/CLOSE' },
];

export const ConstMotorChannelType = [
    { code: 0x0100, text: 'RUN' },
    { code: 0x0101, text: 'RUN-A' },
    { code: 0x0102, text: 'RUN-B' },
    { code: 0x0103, text: 'RUN-C' },
    { code: 0x0104, text: 'RUN-D' },
    { code: 0x0105, text: 'RUN-E' },
    { code: 0x0106, text: 'RUN-F' },
    { code: 0x0107, text: 'RUN-G' },
    { code: 0x0108, text: 'RUN-H' },
    { code: 0x0109, text: 'RUN-I' },
    { code: 0x010a, text: 'RUN-J' },
    { code: 0x010b, text: 'RUN-K' },
];
